import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { TenantService } from '@services';
import UiValidators, { UI_EMAIL_MAX_LENGTH, UI_NAME_LONG_MAX_LENGTH, UI_NAME_MAX_LENGTH, UI_PASSWORD_MAX_LENGTH, } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
var CONNECTION_STRING_CONTROL_KEY = 'connectionString';
var TenantModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TenantModalComponent, _super);
    function TenantModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this._tenantService = _this._injector.get(TenantService);
        _this._appState = _this._injector.get(AppStateFacade);
        _this._connectionStringControl = new FormControl('', UiValidators.required());
        return _this;
    }
    TenantModalComponent.prototype.ngOnInit = function () {
        if (!this.context.isNewEntry) {
            this._dialogRef.close();
            return;
        }
        this.passwordComplexity = this._appState.settings.passwordComplexity;
        this.isMultipleDatabasesEnabled = this._appState.settings.get(Setting.isMultipleDatabasesEnabled);
        var fb = this._injector.get(FormBuilder);
        this.form = fb.group({
            'name': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_NAME_LONG_MAX_LENGTH),
                    UiValidators.required(),
                    UiValidators.regex('^[\\p{L}][\\p{L}0-9-_]+$'),
                ]),
            ],
            'adminEmailAddress': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                    UiValidators.email(true),
                ]),
            ],
            'adminName': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_NAME_MAX_LENGTH),
                ]),
            ],
            'adminSurname': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_NAME_MAX_LENGTH),
                ]),
            ],
            'adminPassword': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                    UiValidators.complexity(this.passwordComplexity),
                ]),
            ],
            'adminPasswordConfirmation': [
                '',
                Validators.compose([
                    Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                ]),
            ],
            'hasConnectionString': [
                false,
            ],
        }, {
            validator: UiValidators.confirmPassword('adminPassword', 'adminPasswordConfirmation'),
        });
    };
    TenantModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        this.loading$.next(true);
        var payloadPatch = cloneDeep(this.form.value);
        delete payloadPatch['adminPasswordConfirmation'];
        Object.assign(this.context.data, payloadPatch);
        if (this.context.isNewEntry) {
            this._tenantService.add(this.context.data)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 1 /* Add */,
                });
            });
        }
        else {
            var clone_1 = cloneDeep(this.context.data);
            this._tenantService.update(this.context.data.id, clone_1)
                .pipe(finalize(function () { return _this.loading$.next(false); }))
                .subscribe(function () {
                _this._dialogRef.close({
                    type: 2 /* Update */,
                    data: clone_1,
                });
            });
        }
    };
    TenantModalComponent.prototype.hasConnectionStringChanged = function (event) {
        if (event.checked) {
            this.form.addControl(CONNECTION_STRING_CONTROL_KEY, this._connectionStringControl);
        }
        else {
            this.form.removeControl(CONNECTION_STRING_CONTROL_KEY);
        }
    };
    return TenantModalComponent;
}(UiModalComponent));
export { TenantModalComponent };
